import { defineStore } from 'pinia';
export default defineStore('townModal', function () {
  var isActive = ref(false);
  var afterTownSelectHandler = ref();
  function open(payload) {
    isActive.value = true;
    afterTownSelectHandler.value = payload === null || payload === void 0 ? void 0 : payload.afterTownSelectHandler;
  }
  function close() {
    isActive.value = false;
    afterTownSelectHandler.value = undefined;
  }
  return {
    isActive: isActive,
    afterTownSelectHandler: afterTownSelectHandler,
    open: open,
    close: close
  };
});